var messages = {
  perPage: '件/ページ',
  prevPage: '前のページ',
  nextPage: '次のページ',
  prevFivePage: '5ページ 戻る',
  nextFivePage: '5ページ 進む',
  sum: '総計',
  oneUnit: '件',
  goTo: '次へ',
  page: 'ページ'
};
export default messages;